import React from "react";
// import ReactSelect from "react-select";
import styled from "styled-components";
import FormikSelect from "../Formik/FormikSelect";
import FormikInput from "../Formik/FormikInput";
import FormikSelectWithModel from "../Formik/FormikSelectWithModal/FormikSelectWithModel";
import { alternativeProductsLoadMoreTableHeading } from "../../utilities/constants";
import { useLanguage } from "../LangTranslation/LanguageContext";
import Translator from "./Translator";
import { primaryColor } from "../../utilities/colors";
import { findAndAddOption } from "../../utilities/findAndAddOption";

const ECommerceContainer = styled.div`
  margin:15px 0px 40px 0px
  padding: 14px 10px 14px 10px;

  .DescriptionBox {
    margin:10px 0px 0px 25px;
    padding: 10px;
    width: 800px !important;
    border: 1px solid #cbcbcb;
    height: 160px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  .shop_text {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    color:#4E5D78;
    margin-bottom:10px;
  }
`;
const ECommerce = ({
  formData,
  productId,
  fieldName,
  fieldValue,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  productList,
  setUpdatedData,
  disabled,
  publicCategoriesList,
  setPublicCategoriesList,
  handleCreatePublicCategory,
  handleCustomSearch,
  company_id,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <ECommerceContainer>
      <div className="row">
        <div className="shop_text">{t["Shop"]}</div>
        <div className="col-md-6">
          {
            <FormikSelect
              disabled={disabled}
              options={publicCategoriesList}
              label={t["Categories"]}
              name="public_categ_ids"
              isMulti
              handleSearch={({ ...args }) => {
                handleCustomSearch({
                  ...args,
                  model: "product.public.category",
                  args: [["website_id.company_id", "=", company_id]],
                });
              }}
              onChange={(op) => {
                // console.log(op, "public_categ_ids.......................");
                findAndAddOption({
                  incomingOption: [op.value, op.label],
                  setAvailableOptions: setPublicCategoriesList,
                });
              }}
              handleCreate={handleCreatePublicCategory}
            />
          }
        </div>

        <div
          className="col-md-12 d-flex flex-column"
          style={{ position: "relative" }}
        >
          {!disabled && (
            <Translator
              productId={productId}
              color={primaryColor.primary}
              fieldName={fieldName}
              fieldValue={fieldValue}
              isCreateModalOpen={isCreateModalOpen}
              setIsCreateModalOpen={setIsCreateModalOpen}
              updatedData={updatedData}
              setUpdatedData={setUpdatedData}
            />
          )}
          <FormikInput
            disabled={disabled}
            maxLength="150"
            textArea
            name="description_sale"
            label={t["Description"] + " (limit: 150 words)"}
          />
        </div>
      </div>
    </ECommerceContainer>
  );
};

export default ECommerce;
